var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"resource":"cdn_domains","base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"statusModule":"cdnDomain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }